import apiClient from "../utils/fetchInstance";

// Backend base url
// const backendBaseUrl = process.env.REACT_APP_API_URL;

// User token
// const user_token = getUser()?.accessToken;

// api to invite a user using fetch
export const inviteUser = async (data) => {
  return await apiClient({ endpoint: "invite/create", method: "post", data });
  // try {
  //   const response = await fetch(`${backendBaseUrl}/invite/create`, {
  //     method: "post",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${user_token}`,
  //     },
  //     body: JSON.stringify(data),
  //   });
  //   console.log("response:", response);
  //   return response.json();
  // } catch (error) {
  //   console.error(error);
  // }
};

// api to get invite details
export const getInviteDetails = async (invite_token) => {
  return await apiClient({ endpoint: `invite/${invite_token}`, method: "get" });
}

// api to validate invite email with id using fetch
export const validateInviteEmailWithId = async (data) => {
  return await apiClient({
    endpoint: "invite/validate",
    method: "post",
    data,
  });
};

// api to register a farmer
export const registerFarmer = async (data, token) => {
  return await apiClient({
    endpoint: "register/farmer",
    method: "post",
    data,
    token,
  });
};

export const getFarmerDetails = async (token) => {
  return await apiClient({
    endpoint: "farmer/profile",
    method: "get",
    token,
  });
};

export const getOrgDetails = async (token) => {
  return await apiClient({ endpoint: "org/profile", method: "get", token });
};

export const getQuestionByOrder = async (order) => {
  return await apiClient({ endpoint: `questions/${order}`, method: "get" });
};

export const getAllQuestions = async () => {
  return await apiClient({ endpoint: "questions/all", method: "get" });
};

export const submitAnswer = async (data) => {
  return await apiClient({
    endpoint: "answer/register",
    method: "post",
    data,
  });
};

export const updateAnswer = async (data) => {
  return await apiClient({
    endpoint: "answer/update",
    method: "put",
    data,
  });
};

export const getFarmerQuestion = async () => {
  return await apiClient({ endpoint: "questions/farmer", method: "get" });
};

// org farmers detail list api
export const getOrgInviteDetails = async (search = '', page = 3, org_id = null) => {
  return await apiClient({
    endpoint: "org/invite_details", method: "get",
    query: { search, page, org_id }
  });
};

// export const questionAnalytics = async () => {
//   return await apiClient({ endpoint: "analytics", method: "get" });
// }

export const questionAnalytics = async ({ org_id = null, farmer_id = null }) => {
  return await apiClient({ endpoint: "analytics", method: "post", data: { org_id, farmer_id } });
}

export const registerOrg = async (data, token) => {
  return await apiClient({ endpoint: "register/org", method: "post", data, token });
}

export const inviteOrg = async (data) => {
  return await apiClient({ endpoint: "invite/create/org", method: "post", data });
}

export const getFarmerAnswers = async () => {
  return await apiClient({ endpoint: "farmer/responses", method: "get" });
};

export const getSpentByEthnicityDetails = async (state, orgId = null) => {
  return await apiClient({
    endpoint: `ethnic_analytics/${state}`,
    method: "get",
    query: orgId ? { org_id: orgId } : undefined
  });
}

export const getCategoryAnalyst = async (state, orgId = null) => {
  return await apiClient({
    endpoint: `category_analytics/${state}`,
    method: "get",
    query: orgId ? { org_id: orgId } : undefined
  });
}

export const getAllOrg = async () => {
  return await apiClient({ endpoint: `super_admin/org_list`, method: "get" });
}

export const getOrgAnalytics = async (orgId) => {
  return await apiClient({ endpoint: `super_admin/analytics/${orgId}`, method: "get" });
}

export const getSpecificOrgList = async (search = '', page = 1) => {
  return await apiClient({
    endpoint: `super_admin/invite_details`, method: "get",
    query: { search, page }
  });
}

// Delete farmer
export const deleteFarmer = async (farmerId) => {
  return await apiClient({ endpoint: `org/delete_farmer/${farmerId}`, method: "delete" });
}

export const deleteOrganization = async (org_id) => {
  return await apiClient({ endpoint: `super_admin/org_delete/${org_id}`, method: "delete" });
}

export const updateFarmerProfile = async (about_me) => {
  return await apiClient({
    endpoint: "farmer/about_me",
    method: "post",
    data: { about_me },
  });
};

export const farmerResponses = async (farmer_id) => {
  return await apiClient({ endpoint: `farmer/answers/${farmer_id}`, method: "get" });
}

export const uploadFarmerImage = async (imageData) => {
  return await apiClient({
    endpoint: 'farmer/profile_pic',
    method: 'POST',
    data: imageData,
  });
};

export const getMapList = async (org_id) => {
  return await apiClient({ endpoint: org_id ? `org/farm_states/${org_id}` : 'org/farm_states', method: 'get' });
}

export const getOrgFarmers = async (org_id) => {
  return await apiClient({ endpoint: `org/farmer_list/${org_id}`, method: 'get' });
}

export const searchAddress = async (address) => {
  return await apiClient({ endpoint: `api/google/search/${address}`, method: 'get' });
}

export const getAddressDetails = async (placeId) => {
  return await apiClient({ endpoint: `api/google/places/${placeId}`, method: 'get' });
}